// Generated by CoffeeScript 1.9.3
var _LineWrapper;

module.exports = _LineWrapper = (function() {
  function _LineWrapper() {}

  _LineWrapper.prototype.render = function(str, options) {
    return this._render(str, options);
  };

  return _LineWrapper;

})();



//////////////////
// WEBPACK FOOTER
// ./~/renderkid/lib/layout/block/lineWrapper/_LineWrapper.js
// module id = 3846
// module chunks = 0